import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Observable, Subject, catchError } from 'rxjs';
import { CompanyInformationModel, VendorModel } from 'src/app/assessment/models/assessment.model';
import { MessageService } from 'src/app/common/message.service';
import { environment } from 'src/environments/environment';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
    providedIn: 'root',
})
export class VendorService {
    private subject = new Subject<any>();
    private changeIndexSubject = new Subject<any>();
    http: HttpClient;
    clientUrl: string = environment.apiUrl + '/Vendor';

    constructor(httpClient: HttpClient, private messageService: MessageService) {
        this.http = httpClient;
    }

    goToPage(index: string) {
        this.changeIndexSubject.next(index);
    }

    getIndexSubjectEvent(): Observable<any> {
        return this.changeIndexSubject.asObservable();
    }
    sendNextEvent(event: any) {
        this.subject.next(event);
    }

    getNextEvent(): Observable<any> {
        return this.subject.asObservable();
    }

    public getAssessment(): Observable<HttpResponse<VendorModel[]>> {
        return this.http.get<VendorModel[]>(this.clientUrl + '/GetAll', {
            observe: 'response',
        });
    }

    GetAllCompanyModels(): Observable<HttpResponse<CompanyInformationModel[]>> {
        return this.http.get<CompanyInformationModel[]>(this.clientUrl + '/GetAllCompany', {
            observe: 'response',
        });
    }
    public checkNewVendors(): Observable<VendorModel[]> {
        return this.http.post<VendorModel[]>(this.clientUrl + '/CheckNewVendors', httpOptions);
    }

    public clearNewVendor(VendorModel: VendorModel): Observable<VendorModel[]> {
        return this.http.post<any>(this.clientUrl + '/ClearNewVendor', VendorModel, httpOptions);
    }

    public updateAssessment(VendorModel: VendorModel): Observable<VendorModel[]> {
        return this.http.post<VendorModel[]>(this.clientUrl, VendorModel, httpOptions);
    }
}
